import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  catalogTypeStartDelete,
  selectCatalogTypes,
  startLoadingCatalogTypesPaginated,
  startSearchingCatalogTypesPaginated,
} from "../../app/actions/catalogTypeActions";
import NavbarIconsCatalogTypes from "../generic-nav-bar/NavbarIconsCatalogTypes";
import Pagination from "../generic-ui/Pagination";
import Select from "../generic-ui/Select";

import { useTranslation } from "react-i18next";
import { useTracking } from "react-tracking";
import { debugLogPages } from "../../app/helpers/debugHelper";
import SearchBackCatalogType from "./SearchBackCatalogType";
import TableCatalogTypes from "./TableCatalogTypes";

const ID_FORM = "admin-catalog-type";
const OPERATION = "list";

const listOptions = [2, 3, 4, 5, 10, 15, 20, 25, 50, 100];

const ListCatalogTypes = () => {
  debugLogPages(':: ListCatalogTypes');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const { searchTextState, catalogTypesS, catalogTypesP, totalPagesP, totalItemsP, currentPageP, totalPagesS, totalItemsS, currentPageS } =
    useSelector((state) => state.catalogType);

  const [, setCurrentPageClick] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageInitial] = useState(0);
  const [searchText, setSearchText] = useState(searchTextState || "");

  useEffect(() => {
    dispatch(startLoadingCatalogTypesPaginated(pageInitial, itemsPerPage));
    setSearchText("");
  }, []);

  const onEditRow = (row) => {
    trackEvent({ component: "EditCatalogTypes", method: "onEditRow", event: "EditCatalogTypes-Clicked" });

    dispatch(selectCatalogTypes(row));
    if (catalogTypesS && catalogTypesS.length > 0) {
      navigate("/admin-catalog-type/edit-catalog-type", {
        state: { searchTextNavListUser: searchText },
      });
    } else {
      navigate("/admin-catalog-type/edit-catalog-type");
    }
  };

  const onDeleteRow = (row) => {
    trackEvent({ component: "DeleteCatalogTypes", method: "onDeleteRow", event: "DeleteCatalogTypes-Clicked" });
    dispatch(catalogTypeStartDelete(row.id));
  };

  const onPageChange = (pageClick) => {

    if (catalogTypesS && catalogTypesS.length > 0) {
      dispatch(startSearchingCatalogTypesPaginated(searchText, pageClick - 1, itemsPerPage));
    } else {
      dispatch(startLoadingCatalogTypesPaginated(pageClick - 1, itemsPerPage));
    }
    setCurrentPageClick(pageClick);
  };

  const onChangeSelect = (event) => {
    setItemsPerPage(event.target.value);
    if (catalogTypesS && catalogTypesS.length > 0) {
      dispatch(startSearchingCatalogTypesPaginated(searchText, 0, event.target.value));
    } else {
      dispatch(startLoadingCatalogTypesPaginated(0, event.target.value));
    }
    setCurrentPageClick(0);
    setItemsPerPage(event.target.value);
  };

  return (
    <>
      <NavbarIconsCatalogTypes page={"listCatalogTypes"} />

      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <SearchBackCatalogType searchText={searchText} setSearchText={setSearchText} itemsPerPage={itemsPerPage} />

      {catalogTypesS && catalogTypesS.length > 0 ? (
        <TableCatalogTypes data={catalogTypesS} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      ) : (
        <TableCatalogTypes data={catalogTypesP} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      )}

      <div>
        <Select listOptions={listOptions} onChangeSelect={onChangeSelect} pageSize={itemsPerPage} />
      </div>

      <div className="pagination justify-content-center">
        {catalogTypesS && catalogTypesS.length > 0 ? (
          <Pagination
            totalPages={totalPagesS}
            totalItems={totalItemsS}
            currentPage={currentPageS + 1}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        ) : (
          <Pagination
            totalPages={totalPagesP}
            totalItems={totalItemsP}
            currentPage={currentPageP + 1}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </>
  );
};

export default ListCatalogTypes;
